import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "objArr" })
export class ObjArrPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let objArr: any[] = [];
    for (let o in obj) objArr.push(obj[o]);
    return objArr;
  }
}
